import React, { useEffect, useState } from "react";
import "./EditChargerModal.css";
import AddAgencyModalLogo from "../../../assets/images/addAgencyModalLogo.svg";
import { Button } from "primereact/button";
import { connect, useSelector } from "react-redux";
import * as yup from "yup";

import "react-phone-input-2/lib/bootstrap.css";
import {
  CommonDate,
  CommonDropdown,
  CommonInputField,
} from "../../common-input";
import { useFormik } from "formik";
import {
  BUS_MANUFACTURERS,
  BUS_TECHNOLOGY,
} from "../../../constants/constant.data";
import { updateBus } from "../../../services/buses.services";
import useToast from "../../../context/toast.hook";
import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import moment from "moment";

const EditBusModal = ({ toggleModal, busData }) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 800px)",
  });
  const [selectedTechnology, setSelectedTechnology] = useState([]);
  const { errorToast, successToast, toastRef } = useToast();
  const { currentUser } = useSelector((state) => state.user);
  const { allAgencies } = useSelector((state) => state.agencies);

  const schema = yup.object().shape({
    agencyId: yup
      .string()
      .test("requiredForAdmin", "Agency is required", function (value) {
        if (currentUser?.role === "admin") {
          return !!value;
        }
        return true;
      }),
    busNumberPlate: yup.string().required("Bus No is required"),
    technology: yup.string().required("Technology is required"),
    busCapacity: yup.string(),
    busLength: yup.string(),
    busManufacturer: yup.string().required("Bus Manufacturer is required"),
    serviceStartedAt: yup.string().required("Model Year is required"),
    busFuelCapacity: yup
      .string()
      .test("requiredForFuel", "Fuel Capacity is required", function (value) {
        if (
          selectedTechnology?.length &&
          selectedTechnology?.find((x) => ["FC", "DSL", "CNG"].includes(x?.key))
        ) {
          return !!value;
        }
        return true;
      }),
    busBatteryCapacity: yup
      .string()
      .test(
        "requiredForBattery",
        "Battery Capacity is required",
        function (value) {
          if (
            selectedTechnology?.length &&
            selectedTechnology?.find((x) => ["FC", "BEB"].includes(x?.key))
          ) {
            return !!value;
          }
          return true;
        }
      ),
  });

  const handleSubmit = (value) => {
    value.busBatteryCapacity = ["FC", "BEB"]?.includes(value?.technology)
      ? value?.busBatteryCapacity
      : "";
    value.busFuelCapacity = ["FC", "DSL", "CNG"]?.includes(value?.technology)
      ? value?.busFuelCapacity
      : "";
    const currentDate = new Date(value.serviceStartedAt);
    currentDate.setDate(currentDate.getDate() + 5);
    value.serviceStartedAt = currentDate;
    updateBus(busData?._id, value)
      .then((res) => {
        successToast(res?.data?.message);
        toggleModal();
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      agencyId: busData?.agencyId?._id || "",
      busNumberPlate: busData?.busNumberPlate || "",
      technology: busData?.technology || "",
      busCapacity: busData?.busCapacity || "",
      busLength: busData?.busLength || "",
      busFuelCapacity: busData?.busFuelCapacity || "",
      busBatteryCapacity: busData?.busBatteryCapacity || "",
      busManufacturer: busData?.busManufacturer || "",
      serviceStartedAt: busData?.serviceStartedAt || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (busData && Object.keys(busData)?.length > 0) {
      setSelectedTechnology(
        BUS_TECHNOLOGY?.filter((x) => x.key === busData?.technology)
      );
    }
  }, [busData]);

  return (
    <>
      <Toast ref={toastRef} />
      <div className="modal">
        <div className="modalInternals">
          <img
            className="logoModal"
            src={AddAgencyModalLogo}
            alt="ModalLogo"
          ></img>
          <br />
          <span className="modalHeading">Edit Bus</span>
          <br />

          <div className="inputFieldsFlex">
            {currentUser?.role === "admin" && (
              <div className="inputFieldBoxCharger">
                <strong>Select Agency</strong>
                <br />
                <CommonDropdown
                  formik={formik}
                  name="agencyId"
                  optionArray={allAgencies}
                  optionKey="_id"
                  optionLabel="name"
                  placeholder="Select Agency"
                  label="Agency"
                  style={{
                    marginTop: "7px",
                  }}
                />
              </div>
            )}
            <div className="inputFieldBox">
              <strong>Number Plate</strong>
              <br />
              <CommonInputField
                formik={formik}
                style={{
                  width: "100%",
                  marginTop: "7px",
                  backgroundColor: "#F9F9F9",
                }}
                placeholder="BV 2666"
                name="busNumberPlate"
              />
            </div>

            <div className="inputFieldBox">
              <label htmlFor="email" className="block text-800">
                <strong>Manufactured by</strong>
              </label>
              <CommonDropdown
                formik={formik}
                name="busManufacturer"
                optionArray={BUS_MANUFACTURERS}
                optionKey="key"
                optionLabel="label"
                placeholder="Manufactured by"
                label="Manufactured by"
                style={{
                  marginTop: "7px",
                }}
              />
            </div>

            <div className="inputFieldBox">
              <label htmlFor="email" className="block text-800">
                <strong>Model Year</strong>
              </label>

              <CommonDate
                placeholder="Click here to select a year"
                formik={formik}
                name="serviceStartedAt"
                view="year"
                dateFormat="yy"
                style={{
                  marginTop: "7px",
                }}
                isNew={!formik.values.serviceStartedAt && true}
              />
            </div>

            <div className="inputFieldBox">
              <label htmlFor="email" className="block text-800">
                <strong>Propulsion</strong>
              </label>
              <CommonDropdown
                // formik={formik}
                name="technology"
                optionArray={BUS_TECHNOLOGY}
                optionKey="key"
                optionLabel="key"
                placeholder="Select Technology"
                label="Propulsion"
                style={{
                  marginTop: "7px",
                }}
                value={formik?.values["technology"]}
                onChange={(e) => {
                  formik.handleChange(e);
                  setSelectedTechnology(
                    BUS_TECHNOLOGY.filter((x) => x.key === e?.target?.value)
                  );
                }}
              />
              {formik &&
              formik.touched.technology &&
              Boolean(formik.errors.technology) ? (
                <small id="email-help" className="p-error block">
                  {formik.errors.technology}
                </small>
              ) : null}
              {selectedTechnology?.length ? (
                <div className="noBusesBox">
                  {selectedTechnology[0]?.capacity?.map((tech) => (
                    <>
                      <div className="noBox">
                        <strong>
                          {tech?.label}{" "}
                          {tech?.unit === "(kg H2)" ? (
                            <span>
                              (kg H<sub>2</sub>)
                            </span>
                          ) : (
                            tech?.unit
                          )}
                        </strong>
                        <br />
                        <CommonInputField
                          formik={formik}
                          style={{
                            width: !isMobile ? "228px" : "100%",
                            marginTop: "7px",
                            backgroundColor: "#F9F9F9",
                          }}
                          placeholder="333"
                          name={tech?.name}
                          type="number"
                        />
                      </div>
                      {selectedTechnology[0]?.key !== "FC" ? (
                        <div className="noBox">
                          <strong>Bus Length (ft)</strong>
                          <br />
                          <CommonInputField
                            formik={formik}
                            style={{
                              width: !isMobile ? "228px" : "100%",
                              marginTop: "7px",
                              backgroundColor: "#F9F9F9",
                            }}
                            placeholder="4 Feet"
                            name="busLength"
                            type="number"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ))}
                </div>
              ) : (
                ""
              )}
              {selectedTechnology?.length &&
              selectedTechnology[0].key === "FC" ? (
                <div className="noBusesBox">
                  <div className="noBox">
                    <strong>Bus Length (ft)</strong>
                    <br />
                    <CommonInputField
                      formik={formik}
                      style={{
                        width: !isMobile ? "228px" : "100%",
                        marginTop: "7px",
                        backgroundColor: "#F9F9F9",
                      }}
                      placeholder="4 Feet"
                      name="busLength"
                      type="number"
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="addBackBox">
                <div className="addButton">
                  <Button
                    label="Update"
                    style={{
                      background: "#1C9894",
                      width: "140px",
                      border: "0",
                    }}
                    onClick={formik.handleSubmit}
                  />
                </div>
                <div className="addButton">
                  <Button
                    label="Back"
                    style={{
                      background: "#FFFFFF",
                      width: "140px",
                      color: "#1C9894",
                      marginLeft: "20px",
                      borderColor: "#1C9894",
                    }}
                    onClick={() => {
                      toggleModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(true);
        }}
      ></div>
    </>
  );
};

export default EditBusModal;
